"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersistentConnection = void 0;
var tslib_1 = require("tslib");
var shared_utils_1 = require("@d-fischer/shared-utils");
var typed_event_emitter_1 = require("@d-fischer/typed-event-emitter");
var PersistentConnection = /** @class */ (function (_super) {
    tslib_1.__extends(PersistentConnection, _super);
    function PersistentConnection(_type, _connectionInfo, config, _additionalOptions) {
        if (config === void 0) { config = {}; }
        var _a;
        var _this = _super.call(this) || this;
        _this._type = _type;
        _this._connectionInfo = _connectionInfo;
        _this._additionalOptions = _additionalOptions;
        _this._retryLimit = Infinity;
        _this._connecting = false;
        _this._connectionRetryCount = 0;
        _this.onReceive = _this.registerEvent();
        _this.onConnect = _this.registerEvent();
        _this.onDisconnect = _this.registerEvent();
        _this.onEnd = _this.registerEvent();
        _this._retryLimit = (_a = config.retryLimit) !== null && _a !== void 0 ? _a : Infinity;
        _this._logger = config.logger;
        return _this;
    }
    Object.defineProperty(PersistentConnection.prototype, "isConnected", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this._currentConnection) === null || _a === void 0 ? void 0 : _a.isConnected) !== null && _b !== void 0 ? _b : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PersistentConnection.prototype, "isConnecting", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this._currentConnection) === null || _a === void 0 ? void 0 : _a.isConnecting) !== null && _b !== void 0 ? _b : this._connecting;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PersistentConnection.prototype, "host", {
        get: function () {
            return this._connectionInfo.hostName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PersistentConnection.prototype, "port", {
        get: function () {
            return this._connectionInfo.port;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PersistentConnection.prototype, "hasSocket", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this._currentConnection) === null || _a === void 0 ? void 0 : _a.hasSocket) !== null && _b !== void 0 ? _b : false;
        },
        enumerable: false,
        configurable: true
    });
    PersistentConnection.prototype.sendLine = function (line) {
        var _a;
        (_a = this._currentConnection) === null || _a === void 0 ? void 0 : _a.sendLine(line);
    };
    PersistentConnection.prototype.connect = function () {
        var _a, _b, _c;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _loop_1, this_1, state_1;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        (_a = this._logger) === null || _a === void 0 ? void 0 : _a.trace("PersistentConnection connect currentConnectionExists:" + Boolean(this._currentConnection).toString() + " connecting:" + this._connecting.toString());
                        if (this._currentConnection || this._connecting) {
                            throw new Error('Connection already present');
                        }
                        this._connectionRetryCount = 0;
                        this._connecting = true;
                        this._retryTimerGenerator = PersistentConnection._getReconnectWaitTime();
                        _loop_1 = function () {
                            var newConnection, e_1, secs;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        newConnection = (this_1._currentConnection = new this_1._type(this_1._connectionInfo, this_1._logger, this_1._additionalOptions));
                                        newConnection.onReceive(function (line) { return _this.emit(_this.onReceive, line); });
                                        newConnection.onConnect(function () { return _this.emit(_this.onConnect); });
                                        newConnection.onDisconnect(function (manually, reason) {
                                            _this.emit(_this.onDisconnect, manually, reason);
                                            if (manually) {
                                                _this.emit(_this.onEnd, true);
                                                void newConnection.disconnect();
                                                if (_this._currentConnection === newConnection) {
                                                    _this._currentConnection = undefined;
                                                }
                                            }
                                            else if (!_this._connecting) {
                                                void _this.reconnect();
                                            }
                                        });
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, , 5]);
                                        return [4 /*yield*/, newConnection.connect()];
                                    case 2:
                                        _a.sent();
                                        this_1._connecting = false;
                                        return [2 /*return*/, { value: void 0 }];
                                    case 3:
                                        e_1 = _a.sent();
                                        if (!this_1._connecting) {
                                            return [2 /*return*/, { value: void 0 }];
                                        }
                                        this_1._connectionRetryCount++;
                                        secs = this_1._retryTimerGenerator.next().value;
                                        if (secs !== 0) {
                                            (_b = this_1._logger) === null || _b === void 0 ? void 0 : _b.info("Retrying in " + secs + " seconds");
                                        }
                                        return [4 /*yield*/, shared_utils_1.delay(secs * 1000)];
                                    case 4:
                                        _a.sent();
                                        (_c = this_1._logger) === null || _c === void 0 ? void 0 : _c.info('Trying to reconnect');
                                        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                                        if (!this_1._connecting) {
                                            return [2 /*return*/, { value: void 0 }];
                                        }
                                        return [3 /*break*/, 5];
                                    case 5: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _d.label = 1;
                    case 1:
                        if (!(this._connectionRetryCount <= this._retryLimit)) return [3 /*break*/, 3];
                        return [5 /*yield**/, _loop_1()];
                    case 2:
                        state_1 = _d.sent();
                        if (typeof state_1 === "object")
                            return [2 /*return*/, state_1.value];
                        return [3 /*break*/, 1];
                    case 3:
                        this.emit(this.onEnd, false, new Error("Connection failed after trying " + this._retryLimit + " times"));
                        return [2 /*return*/];
                }
            });
        });
    };
    PersistentConnection.prototype.disconnect = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var lastConnection;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this._logger) === null || _a === void 0 ? void 0 : _a.trace("PersistentConnection disconnect currentConnectionExists:" + Boolean(this._currentConnection).toString() + " connecting:" + this._connecting.toString());
                        this._connecting = false;
                        if (!this._currentConnection) return [3 /*break*/, 2];
                        lastConnection = this._currentConnection;
                        this._currentConnection = undefined;
                        return [4 /*yield*/, lastConnection.disconnect()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PersistentConnection.prototype.assumeExternalDisconnect = function () {
        var _a, _b;
        (_a = this._logger) === null || _a === void 0 ? void 0 : _a.trace('PersistentConnection assumeExternalDisconnect');
        (_b = this._currentConnection) === null || _b === void 0 ? void 0 : _b.assumeExternalDisconnect();
    };
    PersistentConnection.prototype.reconnect = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                void this.disconnect().catch(function (e) { var _a; return (_a = _this._logger) === null || _a === void 0 ? void 0 : _a.error("Error while disconnecting for the reconnect: " + e.message); });
                return [2 /*return*/, this.connect()];
            });
        });
    };
    // yes, this is just fibonacci with a limit
    PersistentConnection._getReconnectWaitTime = function () {
        var current, next;
        var _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    current = 0;
                    next = 1;
                    _b.label = 1;
                case 1:
                    if (!(current < 120)) return [3 /*break*/, 3];
                    return [4 /*yield*/, current];
                case 2:
                    _b.sent();
                    _a = [next, current + next], current = _a[0], next = _a[1];
                    return [3 /*break*/, 1];
                case 3:
                    if (!true) return [3 /*break*/, 5];
                    return [4 /*yield*/, 120];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 5: return [2 /*return*/];
            }
        });
    };
    return PersistentConnection;
}(typed_event_emitter_1.EventEmitter));
exports.PersistentConnection = PersistentConnection;
//# sourceMappingURL=PersistentConnection.js.map